import {
  CHECK_AUTHENTICATION,
  LOGIN,
  LOGOUT,
    CHECK_LOGIN,
    CANCEL_CHECK_LOGIN
} from './auth.actionTypes';

const checkAuthentication = data => {
  return dispatch => {
    dispatch({
      type: CHECK_AUTHENTICATION
    });
  }
};

const doLogin = data => {
  return dispatch => {
    dispatch({
      type: LOGIN,
      payload: {
        data
      }
    });
  }
};

const checkLogin = data => {
  return dispatch => {
    dispatch({
      type: CHECK_LOGIN,
      payload: {
        data
      }
    });
  }
};

const cancelCheckLogin = data => {
  return dispatch => {
    dispatch({
      type: CANCEL_CHECK_LOGIN,
      payload: {
        data
      }
    });
  }
};

const doLogout = id => {
  return dispatch => {
    dispatch({
      type: LOGOUT
    });
  }
};

export {
  checkAuthentication,
  doLogin,
  doLogout,
    checkLogin,
    cancelCheckLogin
};



// WEBPACK FOOTER //
// ./src/state/auth/auth.actions.js